const CHANGELOGS_BASE = "/changelogs";

export const CHANGELOGS_ENDPOINTS = {
  GET_CHANGELOGS: CHANGELOGS_BASE,
  GET_CHANGELOG: (id: string) => `${CHANGELOGS_BASE}/${id}`,
  GET_LATEST_POPUP: `${CHANGELOGS_BASE}/latest_popup`,
} as const;
